import styled from 'styled-components';
import { WppTypography } from '@wppopen/components-library-react';

export const Main = styled.div`
    display: flex;
    position: relative;
`;

export const BottomTooltip = styled(WppTypography)<{ isVisible?: boolean }>`
    display: ${({ isVisible = false }) => (isVisible ? 'block' : 'none')};
    position: absolute;
    bottom: -28px;
    color: rgba(77, 83, 88, 1);
`;
